class DatetimeElement extends HTMLElement {
    connectedCallback() {
        const value = this.getAttribute("value");

        let timeStyle: Intl.DateTimeFormatOptions["timeStyle"];
        const timeStyleString = this.getAttribute("timestyle");
        if (timeStyleString) {
            timeStyle =
                timeStyleString as Intl.DateTimeFormatOptions["timeStyle"];
        }

        let dateStyle: Intl.DateTimeFormatOptions["dateStyle"];
        const dateStyleString = this.getAttribute("timestyle");
        if (dateStyleString) {
            dateStyle =
                dateStyleString as Intl.DateTimeFormatOptions["dateStyle"];
        }

        if (!value) {
            return;
        }

        const date = new Date(value);
        const formatted = new Intl.DateTimeFormat(undefined, {
            dateStyle: dateStyle,
            timeStyle: timeStyle,
        }).format(date);
        this.innerText = formatted;
    }
}

customElements.define("bd-datetime", DatetimeElement);
